import { gql } from '@apollo/client';

export const GET_TIMESLOTS = gql`
  query GetTimeslots(
    $productSlug: String!
    $dateFrom: String!
    $dateTo: String!
    $context: RequestContext!
  ) {
    timeslots(productSlug: $productSlug, dateFrom: $dateFrom, dateTo: $dateTo, context: $context) {
      externalId
      date
      quotaAvailable
      quotaUnlimited
      dailyBooking
      limitQuotaOrderVel
      duration
    }
  }
`;
